export default [
  {
    word: 'My',
    startMs: 0,
    endMs: 180,
  },
  {
    word: 'teddy',
    startMs: 180,
    endMs: 440,
  },
  {
    word: 'bear',
    startMs: 440,
    endMs: 620,
  },
  {
    word: 'is',
    startMs: 620,
    endMs: 780,
  },
  {
    word: 'a',
    startMs: 780,
    endMs: 840,
  },
  {
    word: 'superhero.',
    startMs: 840,
    endMs: 1400,
  },
  {
    word: 'He',
    startMs: 2080,
    endMs: 2160,
  },
  {
    word: 'wears',
    startMs: 2160,
    endMs: 2280,
  },
  {
    word: 'a',
    startMs: 2280,
    endMs: 2400,
  },
  {
    word: 'red',
    startMs: 2400,
    endMs: 2520,
  },
  {
    word: 'cape',
    startMs: 2520,
    endMs: 2740,
  },
  {
    word: 'and',
    startMs: 2740,
    endMs: 2960,
  },
  {
    word: 'a',
    startMs: 2960,
    endMs: 3040,
  },
  {
    word: 'blue',
    startMs: 3040,
    endMs: 3180,
  },
  {
    word: 'mask.',
    startMs: 3180,
    endMs: 3440,
  },
  {
    word: 'His',
    startMs: 4040,
    endMs: 4140,
  },
  {
    word: 'name',
    startMs: 4140,
    endMs: 4300,
  },
  {
    word: 'is',
    startMs: 4300,
    endMs: 4500,
  },
  {
    word: 'Captain',
    startMs: 4500,
    endMs: 4760,
  },
  {
    word: 'Fuzzy.',
    startMs: 4760,
    endMs: 5120,
  },
  {
    word: 'One',
    startMs: 6280,
    endMs: 6360,
  },
  {
    word: 'morning',
    startMs: 6360,
    endMs: 6580,
  },
  {
    word: 'I',
    startMs: 6580,
    endMs: 6760,
  },
  {
    word: 'saw',
    startMs: 6760,
    endMs: 6920,
  },
  {
    word: 'our',
    startMs: 6920,
    endMs: 7080,
  },
  {
    word: 'cat',
    startMs: 7080,
    endMs: 7260,
  },
  {
    word: 'Mr.',
    startMs: 7260,
    endMs: 7540,
  },
  {
    word: 'Whiskers',
    startMs: 7640,
    endMs: 7920,
  },
  {
    word: 'stuck',
    startMs: 7920,
    endMs: 8080,
  },
  {
    word: 'in',
    startMs: 8080,
    endMs: 8240,
  },
  {
    word: 'a',
    startMs: 8240,
    endMs: 8320,
  },
  {
    word: 'tall',
    startMs: 8320,
    endMs: 8480,
  },
  {
    word: 'tree.',
    startMs: 8480,
    endMs: 8800,
  },
  {
    word: 'Captain',
    startMs: 9460,
    endMs: 9620,
  },
  {
    word: 'Fuzzy',
    startMs: 9620,
    endMs: 9920,
  },
  {
    word: 'said',
    startMs: 9920,
    endMs: 10100,
  },
  {
    word: "don't",
    startMs: 10100,
    endMs: 10340,
  },
  {
    word: 'worry',
    startMs: 10340,
    endMs: 10600,
  },
  {
    word: 'and',
    startMs: 10600,
    endMs: 10740,
  },
  {
    word: 'he',
    startMs: 10740,
    endMs: 10820,
  },
  {
    word: 'flew',
    startMs: 10820,
    endMs: 11000,
  },
  {
    word: 'up',
    startMs: 11000,
    endMs: 11140,
  },
  {
    word: 'to',
    startMs: 11140,
    endMs: 11240,
  },
  {
    word: 'the',
    startMs: 11240,
    endMs: 11320,
  },
  {
    word: 'top',
    startMs: 11320,
    endMs: 11500,
  },
  {
    word: 'branch.',
    startMs: 11500,
    endMs: 11800,
  },
  {
    word: 'He',
    startMs: 12660,
    endMs: 12800,
  },
  {
    word: 'gently',
    startMs: 12800,
    endMs: 13040,
  },
  {
    word: 'carried',
    startMs: 13040,
    endMs: 13320,
  },
  {
    word: 'Mr.',
    startMs: 13320,
    endMs: 13560,
  },
  {
    word: 'Whiskers',
    startMs: 13660,
    endMs: 13980,
  },
  {
    word: 'down',
    startMs: 13980,
    endMs: 14140,
  },
  {
    word: 'to',
    startMs: 14140,
    endMs: 14280,
  },
  {
    word: 'the',
    startMs: 14280,
    endMs: 14400,
  },
  {
    word: 'soft',
    startMs: 14400,
    endMs: 14640,
  },
  {
    word: 'grass.',
    startMs: 14640,
    endMs: 14960,
  },
  {
    word: 'The',
    startMs: 16000,
    endMs: 16180,
  },
  {
    word: 'cat',
    startMs: 16180,
    endMs: 16360,
  },
  {
    word: 'meowed,',
    startMs: 16360,
    endMs: 16940,
  },
  {
    word: 'happily,',
    startMs: 17280,
    endMs: 17600,
  },
  {
    word: 'and',
    startMs: 18120,
    endMs: 18300,
  },
  {
    word: 'brushed',
    startMs: 18300,
    endMs: 18560,
  },
  {
    word: 'against',
    startMs: 18560,
    endMs: 18880,
  },
  {
    word: 'my',
    startMs: 18880,
    endMs: 19140,
  },
  {
    word: 'leg.',
    startMs: 19140,
    endMs: 19400,
  },
  {
    word: 'Then',
    startMs: 20380,
    endMs: 20580,
  },
  {
    word: 'we',
    startMs: 20580,
    endMs: 20740,
  },
  {
    word: 'all',
    startMs: 20740,
    endMs: 20880,
  },
  {
    word: 'sat',
    startMs: 20880,
    endMs: 21040,
  },
  {
    word: 'on',
    startMs: 21040,
    endMs: 21180,
  },
  {
    word: 'the',
    startMs: 21180,
    endMs: 21300,
  },
  {
    word: 'porch',
    startMs: 21300,
    endMs: 21560,
  },
  {
    word: 'and',
    startMs: 21560,
    endMs: 21740,
  },
  {
    word: 'ate',
    startMs: 21740,
    endMs: 21840,
  },
  {
    word: 'peanut',
    startMs: 21840,
    endMs: 22140,
  },
  {
    word: 'butter',
    startMs: 22140,
    endMs: 22380,
  },
  {
    word: 'sandwiches',
    startMs: 22380,
    endMs: 22800,
  },
  {
    word: 'and',
    startMs: 22800,
    endMs: 23120,
  },
  {
    word: 'drank',
    startMs: 23120,
    endMs: 23260,
  },
  {
    word: 'apple',
    startMs: 23260,
    endMs: 23580,
  },
  {
    word: 'juice.',
    startMs: 23580,
    endMs: 23780,
  },
  {
    word: 'Captain',
    startMs: 24740,
    endMs: 25080,
  },
  {
    word: 'Fuzzy',
    startMs: 25080,
    endMs: 25440,
  },
  {
    word: 'gave',
    startMs: 25420,
    endMs: 25620,
  },
  {
    word: 'me',
    startMs: 25620,
    endMs: 25800,
  },
  {
    word: 'a',
    startMs: 25800,
    endMs: 25900,
  },
  {
    word: 'high',
    startMs: 25900,
    endMs: 26080,
  },
  {
    word: 'five',
    startMs: 26080,
    endMs: 26340,
  },
  {
    word: 'with',
    startMs: 26340,
    endMs: 26560,
  },
  {
    word: 'his',
    startMs: 26560,
    endMs: 26700,
  },
  {
    word: 'fluffy',
    startMs: 26700,
    endMs: 26940,
  },
  {
    word: 'paw.',
    startMs: 26940,
    endMs: 27300,
  },
  {
    word: 'We',
    startMs: 28060,
    endMs: 28240,
  },
  {
    word: 'danced',
    startMs: 28240,
    endMs: 28400,
  },
  {
    word: 'in',
    startMs: 28400,
    endMs: 28640,
  },
  {
    word: 'the',
    startMs: 28640,
    endMs: 28740,
  },
  {
    word: 'sunshine',
    startMs: 28740,
    endMs: 29020,
  },
  {
    word: 'and',
    startMs: 29020,
    endMs: 29660,
  },
  {
    word: 'laughed',
    startMs: 29660,
    endMs: 29780,
  },
  {
    word: 'a',
    startMs: 29780,
    endMs: 29960,
  },
  {
    word: 'lot.',
    startMs: 29960,
    endMs: 30120,
  },
  {
    word: 'I',
    startMs: 30880,
    endMs: 31080,
  },
  {
    word: 'hugged,',
    startMs: 31080,
    endMs: 31460,
  },
  {
    word: 'my',
    startMs: 31920,
    endMs: 32180,
  },
  {
    word: 'teddy',
    startMs: 32180,
    endMs: 32360,
  },
  {
    word: 'tight',
    startMs: 32360,
    endMs: 32700,
  },
  {
    word: 'and',
    startMs: 32700,
    endMs: 32880,
  },
  {
    word: 'said',
    startMs: 32880,
    endMs: 33020,
  },
  {
    word: 'thank',
    startMs: 33020,
    endMs: 33260,
  },
  {
    word: 'you.',
    startMs: 33260,
    endMs: 33480,
  },
  {
    word: 'The',
    startMs: 34060,
    endMs: 34180,
  },
  {
    word: 'end.',
    startMs: 34180,
    endMs: 34480,
  },
];
